import {
  ROUTE_MARKER_ICON,
  ROUTE_MARKER_INNER,
  vehicleMarkerIcon,
  type TrackingVehicleType,
} from 'features/tracking/lib/vehicleMarker';

interface DriverMarkerIconProps {
  bearing: number;
  vehicleType?: TrackingVehicleType;
  className?: string;
  /** Accessible label for map marker */
  label?: string;
  /** Route view uses slightly larger icon */
  variant?: 'map' | 'route';
}

export default function DriverMarkerIcon({
  bearing,
  vehicleType = 'car',
  className = '',
  label = 'Driver location',
  variant = 'route',
}: DriverMarkerIconProps) {
  const icon = vehicleMarkerIcon(vehicleType);
  const inner = variant === 'map' ? 'w-7 h-7' : ROUTE_MARKER_INNER;
  const iconSize = variant === 'map' ? 'text-[15px]' : ROUTE_MARKER_ICON;

  return (
    <div
      className={`flex items-center justify-center ${className}`}
      style={{ transform: `rotate(${bearing}deg)` }}
      role="img"
      aria-label={label}
    >
      <div
        className={`${inner} rounded-full bg-primary shadow-md flex items-center justify-center border border-white ring-1 ring-white/80`}
      >
        <span
          className={`material-symbols-outlined text-white ${iconSize}`}
          style={{ fontVariationSettings: '"FILL" 1' }}
        >
          {icon}
        </span>
      </div>
    </div>
  );
}
